
import React from "react";
import { Button, Link, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";


import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../../../hooks";
import { LoadState } from "../../../../../../../constants/enums";
import {
  fetchAutomobileVehicleListAsync,
} from "../../../../../../../redux/automobileVehicle/automobileVehicleActions";
import { IAutomobileVehicleInformation } from "../../../../../../../redux/automobileVehicle/automobileVehicle.types";
import { StandardTableActions } from "../../../../../../../components/StandardTableActions/StandardTableActions";
import { useTableV2State } from "../../../../../../../components/TableV2/hooks/useTableV2State";
import {
  DataTableV2RowRenderType,
  IDataTableV2Props,
} from "../../../../../../../components/TableV2/interfaces/IDataTableV2Props";
import { ControlledCustomSelect } from "../../../../../../../components/formsComponents";
import { COMMON_STATUS } from "../../../../../../../constants/constants";
import { StatusRenderer } from "../../../../../../../components/ActiveInActiveStatus/ActiveInActiveStatus";
import { PageTitleBar } from "../../../../../../../components/PageTitleBar/PageTitleBar";
import { AddOutlined } from "@mui/icons-material";
import { DataTableV2 } from "../../../../../../../components/TableV2/DataTableV2";
import { ImportVehicleDriverData } from "../../../PoliciesCommon/ImportVehicleDriverData/ImportVehicleDriverData";

export const AutomobileVehicleInformationList: React.FC<{
  customerId: number;
  customerPolicyId: number;
}> = (props) => {
  const { customerId, customerPolicyId } = props;
  const navigate = useNavigate();
  const { vehiclesList, vehiclesListLoading } = useSelector(
    (storeState: IStoreState) =>
      storeState.automobile.vehicle.VehicleInformation
  );
  const [openImport, setOpenImport] = React.useState(false);
  const customerInfo = useSelector(
    (storeState: IStoreState) =>
      storeState.automobile.basicDetails.customerInfo.data
  );


  const dispatch = useDispatchWrapper();
  const [status, setStatus] = React.useState<"ACTIVE" | "INACTIVE" | "-1">(
    "ACTIVE"
  );

  const {
    state: { dateState, searchState, tabs, columnsConfig,
      dense },

    setColumnVisibility,

    onDenseToggle, } = useTableV2State({
      filtersInitialState: {
        defaultDateRange: "allTimes",
        selectedTab: "-1",
      },
    });

  const handleCreate = () => {
    navigate(
      `/automobile-policy/${customerId}/vehicle-tab/${customerPolicyId}/vehicle-information`
    );
  };

  const fetchList = () => {
    if (customerPolicyId) {
      dispatch(fetchAutomobileVehicleListAsync(customerPolicyId, status));
    }
  };

  const handleComplete = () => {
    fetchList();
    setOpenImport(false);
  }

  React.useEffect(() => {
    fetchList();

    // return () => {
    //   dispatch(clearAutomobileVehicleState());
    // };
  }, [customerPolicyId, status]);


  const automobileVehicleTableProps: IDataTableV2Props = {
    isPagination: false,
    isDataLoading: vehiclesListLoading === LoadState.InProgress,
    tableCommandBarProps: {
      preDefinedPlugins: {
        columnVisibility: {
          columnVisibility: columnsConfig.columnVisibility,
          onChange: setColumnVisibility,
        },
        refresh: {
          onClick: fetchList,
        },
      },
      leftItems: {},
      rightItems: {
        customPlugins: [
          {
            key: "status",
            onRender: () => (
              <ControlledCustomSelect
                fullWidth
                value={status}
                name="status"
                onChange={(e) => setStatus(e.target.value as "ACTIVE")}
                placeholder="Select one"
                displayEmpty
                options={COMMON_STATUS}
              />
            ),
          },
        ],
      },
    },
    masterColumns: [
      {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        headingAlign: "center",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IAutomobileVehicleInformation) => {
          return (
            <StandardTableActions
              onEditClick={() => {
                navigate(
                  `/automobile-policy/${customerId}/vehicle-tab/${customerPolicyId}/vehicle-information/${row.incremental_number}`
                );
              }}
            />
          );
        },
      },
      {
        key: "status",
        headerName: "Status",
        fieldName: "status",
        enableSorting: true,
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IAutomobileVehicleInformation) => {
          return <StatusRenderer status={row.status} />;
        },
      },
      {
        key: "incremental_number",
        headerName: "Vehicle Number",
        fieldName: "incremental_number",
        renderType: DataTableV2RowRenderType.TEXT_DARK,
        // exportCellWidth: 15,
      },

      {
        key: "customer_name",
        headerName: "Customer Name",
        fieldName: "customer_name",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        // exportCellWidth: 20,
        onRowCellRender: (value, row: IAutomobileVehicleInformation) => {
          return (
            <Link
              sx={{ cursor: "pointer" }}
              onClick={() => {
                navigate(
                  `/automobile-policy/${customerId}/vehicle-tab/${customerPolicyId}/vehicle-information/${row.incremental_number}`
                );
              }}
            >
              {row.customer_name}
            </Link>
          );
        },
      },

      {
        key: "unit_number",
        headerName: "Unit Name",
        fieldName: "unit_number",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.CHIP_WARNING,
      },

      {
        key: "year",
        headerName: "Year",
        fieldName: "year",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.TEXT,
      },

      {
        key: "make",
        headerName: "Make",
        fieldName: "make",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.TEXT,
      },

      {
        key: "model",
        headerName: "Model",
        fieldName: "model",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.TEXT,
      },
      {
        key: "vin",
        headerName: "VIN",
        fieldName: "vin",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.TEXT,
      },
      {
        key: "owned_or_leased",
        headerName: "Owned/Leased",
        fieldName: "owned_or_leased",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.TEXT,
      },
      {
        key: "purchase_date",
        headerName: "Purchase Date",
        fieldName: "purchase_date",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.TEXT,
      },
      {
        key: "puchase_condition",
        headerName: "Purchase Condition",
        fieldName: "puchase_condition",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.TEXT,
      },
      {
        key: "insert_ts",
        headerName: "Date Modified",
        fieldName: "insert_ts",
        renderType: DataTableV2RowRenderType.DATE_TIME,
      },
    ],
    rows: vehiclesList,
    dense: dense,
    onDenseToggle: onDenseToggle,
  };

  return (
    <>
      <PageTitleBar
        heading="Vehicle Information"
        rightHeading={
          <Stack direction={'row'} spacing={1}>
            <Button
              variant="contained"
              onClick={() => setOpenImport(true)}
              startIcon={<AddOutlined />}
            >
              Import vehicle data
            </Button>
            <Button
              variant="contained"
              onClick={handleCreate}
              startIcon={<AddOutlined />}
            >
              Create
            </Button>
          </Stack>
        }
      />
      <DataTableV2 {...automobileVehicleTableProps} />

      {openImport &&
        <ImportVehicleDriverData
          open={openImport}
          type="VEHICLE"
          customer_id={customerId}
          customer_policy_id={customerPolicyId}
          customer_name={customerInfo.customer_name || ""}
          onClose={() => setOpenImport(false)}
          onComplete={handleComplete}
          policy_type="AUTO"

        />

      }

    </>
  );
};
